import React, { useEffect, useState } from 'react';
import translate from "../../i18n/translate";
import { LOCALES } from '../../i18n';
import { actionChangeLanguage } from "../../store/action/LayoutActionSupervisor";
import connect from "react-redux/es/components/connect";
import ConfirmDialog from "../../components/ConfirmDialog";
import { getMultiLanguageMessage, getMultiLanguageLabel } from '../../i18n/multiLanguage';
import { PAGEID, ACCESSRIGHTSTYPE } from "../../i18n/constants";

const SidebarSupervisor = (props) => {
    const [language, setLanguage] = useState("");
    const useMatchMedia = (mediaQuery, initialValue) => {
        const [isMatching, setIsMatching] = useState(initialValue)
        useEffect(() => {
            const watcher = window.matchMedia(mediaQuery)
            setIsMatching(watcher.matches)
            const listener = (matches) => {
                setIsMatching(matches.matches)
            }
            if (watcher.addEventListener) {
                watcher.addEventListener('change', listener)
            } else {
                watcher.addListener(listener)
            }
            return () => {
                if (watcher.removeEventListener) {
                    return watcher.removeEventListener('change', listener)
                } else {
                    return watcher.removeListener(listener)
                }
            }
        }, [mediaQuery])
        return isMatching
    };
    const isDesktop = useMatchMedia('(min-width:992px)', true);
    const [isAccessRightsLoaded, setIsAccessRightsLoaded] = useState(false);
    const [supervisorAccessRights, setSupervisorAccessRights] = useState({});
    const [email, setEmail] = useState("");
    const [supervisorName, setSupervisorName] = useState("");
    const [sideBarMobile, setSideBarMobile] = useState(false);
    const [isDepositWithdrawExpand, setIsDepositWithdrawExpand] = useState(false);
    const [isTradingExpand, setIsTradingExpand] = useState(false);
    const [isAccountExpand, setIsAccountExpand] = useState(false);
    const [isUserExpand, setIsUserExpand] = useState(false);
    const [isLogExpand, setIsLogExpand] = useState(false);
    const [isAccessRightsExpand, setIsAccessRightsExpand] = useState(false);

    const OnClickTradingMenu = (e) => {
        setIsTradingExpand(!isTradingExpand);
        SaveMenuState(isUserExpand, isDepositWithdrawExpand, isAccountExpand, !isTradingExpand, isLogExpand, isAccessRightsExpand);
    };

    const OnClickAccountMenu = (e) => {
        setIsAccountExpand(!isAccountExpand);
        SaveMenuState(isUserExpand, isDepositWithdrawExpand, !isAccountExpand, isTradingExpand, isLogExpand, isAccessRightsExpand);
    };

    const OnClickLogMenu = (e) => {
        setIsLogExpand(!isLogExpand);
        SaveMenuState(isUserExpand, isDepositWithdrawExpand, isAccountExpand, isTradingExpand, !isLogExpand, isAccessRightsExpand);
    };

    const OnClickAccessRightsMenu = (e) => {
        setIsAccessRightsExpand(!isAccessRightsExpand);
        SaveMenuState(isUserExpand, isDepositWithdrawExpand, isAccountExpand, isTradingExpand, isLogExpand, !isAccessRightsExpand);
    };

    const SaveMenuState = (isUserExpand, isDepositWithdrawMenu, isAccountMenu, isTradingExpand, isLogExpand, isAccessRightsExpand) => {
        const AGATHAMenuState = {
            "isUserExpand": isUserExpand,
            "isDepositWithdrawExpand": isDepositWithdrawMenu,
            "isAccountExpand": isAccountMenu,
            "isTradingExpand": isTradingExpand,
            "isLogExpand": isLogExpand,
            "isAccessRightsExpand": isAccessRightsExpand
        };
        localStorage.setItem("AGATHAMenuState", JSON.stringify(AGATHAMenuState));
    };

    const [Dialog, showConfirmDialog] = ConfirmDialog(
        getMultiLanguageLabel('lbl_ConfirmDialog_Title', language),
        getMultiLanguageMessage('msg_KYCNotCompleted', language),
        getMultiLanguageLabel('lbl_GoToWebPage', language),
        getMultiLanguageLabel('lbl_Close', language)
    );

    useEffect(() => {
        setSideBarMobile(props.sideBarMobile);
    }, [props.sideBarMobile]);

    useEffect(() => {
        setLanguage(localStorage.getItem("locale"));
        if (props?.supervisor?.length > 0) {
            setEmail(props?.supervisor[0].MailID);
            setSupervisorName(props?.supervisor[0].FirstName + ' ' + props?.supervisor[0].LastName);
            let savedMenuState = localStorage.getItem("AGATHAMenuState");
            if (savedMenuState) {
                let objMenuState = JSON.parse(savedMenuState);
                setIsUserExpand(objMenuState.isUserExpand);
                setIsDepositWithdrawExpand(objMenuState.isDepositWithdrawExpand);
                setIsAccountExpand(objMenuState.isAccountExpand);
                setIsTradingExpand(objMenuState.isTradingExpand);
                setIsLogExpand(objMenuState.isLogExpand);
                setIsAccessRightsExpand(objMenuState.isAccessRightsExpand);
            }
            // Set Access Rights
            let sAccessRights = localStorage.getItem("SupervisorAccessRights");
            if (sAccessRights) {
                setSupervisorAccessRights(JSON.parse(sAccessRights));
                setIsAccessRightsLoaded(true);
            }
        }
    }, [props.supervisor]);

    return (isAccessRightsLoaded) ? (
        <div className={"user-sidebar " + (!isDesktop ? 'user-sidebar-mobile' : '') + (sideBarMobile ? ' active' : '')}>
            <div className="user-sidebar-overlay" />
            <div className="user-box d-none d-lg-block">
                <div className="user-image">
                    <img src={require('../../assets/images/user-thumb-sm.png')} alt="thumb" />
                </div>
                <h6 className="user-name">{email}</h6>
                <div className="user-uid">
                    <span>{supervisorName}</span>
                </div>
            </div>
            <ul className="user-icon-nav">
                <li>
                    <a href="/dashboard">
                        <em className="ti ti-home" />
                        {translate('Menu-Top')}
                    </a>
                </li>

                {(supervisorAccessRights[PAGEID.ExchangeRate] && supervisorAccessRights[PAGEID.ExchangeRate].ReadAccess === ACCESSRIGHTSTYPE.Yes) &&
                    <li>
                        <a href="/exchangerate">
                            <em className="ti ti-money" />
                            {translate('Menu-ExchangeRate')}
                        </a>
                    </li>
                }

                {(supervisorAccessRights[PAGEID.Vfasp] && supervisorAccessRights[PAGEID.Vfasp].ReadAccess === ACCESSRIGHTSTYPE.Yes) &&
                    <li>
                        <a href="/clientlist">
                            <em className="ti ti-receipt" />
                            {translate('Menu-ClientList')}
                        </a>
                    </li>
                }

                {(supervisorAccessRights[PAGEID.Tranche] && supervisorAccessRights[PAGEID.Tranche].ReadAccess === ACCESSRIGHTSTYPE.Yes) &&
                    <li>
                        <a href="/tranchelist">
                            <em className="ti ti-receipt" />
                            {translate('Menu-TrancheList')}
                        </a>
                    </li>
                }

                {(supervisorAccessRights[PAGEID.AgathaConfig] && supervisorAccessRights[PAGEID.AgathaConfig].ReadAccess === ACCESSRIGHTSTYPE.Yes) &&
                    <li>
                        <a href="/agathaconfig">
                            <em className="ti ti-receipt" />
                            {translate('Menu-AgathaConfiguration')}
                        </a>
                    </li>
                }

                {(supervisorAccessRights[PAGEID.IssuerConfig] && supervisorAccessRights[PAGEID.IssuerConfig].ReadAccess === ACCESSRIGHTSTYPE.Yes) &&
                    <li>
                        <a href="/issuerconfig">
                            <em className="ti ti-receipt" />
                            {translate('Menu-IssuerConfiguration')}
                        </a>
                    </li>
                }

                {/* Account Menu */}
                <li>
                    <a href="#" onClick={event => OnClickAccountMenu(event)}>
                        <em className="ti ti-user" />
                        {translate('Menu-Account')}
                        <div className="TopMenuIcon">{isAccountExpand ? <em className="ti ti-angle-down" /> : <em className="ti ti-angle-right" />}</div>
                    </a>
                </li>
                {isAccountExpand &&
                    <div className="SubMenu">
                        <li>
                            <a href="/passwordchange">
                                <em className="ti ti-receipt" />
                                {translate('Menu-ChangePassword')}
                            </a>
                        </li>
                        {(supervisorAccessRights[PAGEID.Supervisor] && supervisorAccessRights[PAGEID.Supervisor].ReadAccess === ACCESSRIGHTSTYPE.Yes) &&
                            <li>
                                <a href="/supervisorlist">
                                    <em className="ti ti-receipt" />
                                    {translate('Menu-SupervisorList')}
                                </a>
                            </li>
                        }
                        {(supervisorAccessRights[PAGEID.AdminLogin] && supervisorAccessRights[PAGEID.AdminLogin].ReadAccess === ACCESSRIGHTSTYPE.Yes) &&
                            <li>
                                <a href="/supervisorloginlist">
                                    <em className="ti ti-angle-right" />
                                    <div className="SubMenuText">{translate('Menu-SupervisorLoginList')}</div>
                                </a>
                            </li>
                        }
                    </div>
                }

                {/* Trading Menu */}
                {((supervisorAccessRights[PAGEID.Transaction] && supervisorAccessRights[PAGEID.Transaction].ReadAccess === ACCESSRIGHTSTYPE.Yes) ||
                    (supervisorAccessRights[PAGEID.Execution] && supervisorAccessRights[PAGEID.Execution].ReadAccess === ACCESSRIGHTSTYPE.Yes)) &&
                    <li>
                        <a href="#" onClick={event => OnClickTradingMenu(event)}>
                            <em className="ti ti-money" />
                            {translate('Menu-Trading')}
                            <div className="TopMenuIcon">{isTradingExpand ? <em className="ti ti-angle-down" /> : <em className="ti ti-angle-right" />}</div>
                        </a>
                    </li>
                }
                {isTradingExpand &&
                    <div className="SubMenu">
                        {(supervisorAccessRights[PAGEID.Transaction] && supervisorAccessRights[PAGEID.Transaction].ReadAccess === ACCESSRIGHTSTYPE.Yes) &&
                            <li>
                                <a href="/transactionlist">
                                    <em className="ti ti-receipt" />
                                    {translate('Menu-TransactionList')}
                                </a>
                            </li>
                        }
                        {(supervisorAccessRights[PAGEID.Execution] && supervisorAccessRights[PAGEID.Execution].ReadAccess === ACCESSRIGHTSTYPE.Yes) &&
                            <li>
                                <a href="/executionlist">
                                    <em className="ti ti-book" />
                                    {translate('Menu-ExecutionList')}
                                </a>
                            </li>
                        }
                    </div>
                }

                {((supervisorAccessRights[PAGEID.VfaspAccessRights] && supervisorAccessRights[PAGEID.VfaspAccessRights].ReadAccess === ACCESSRIGHTSTYPE.Yes) ||
                    (supervisorAccessRights[PAGEID.AdminAccessRights] && supervisorAccessRights[PAGEID.AdminAccessRights].ReadAccess === ACCESSRIGHTSTYPE.Yes) ||
                    (supervisorAccessRights[PAGEID.DefaultAdminAccessRights] && supervisorAccessRights[PAGEID.DefaultAdminAccessRights].ReadAccess === ACCESSRIGHTSTYPE.Yes)) &&
                    <li>
                        <a href="#" onClick={event => OnClickAccessRightsMenu()}>
                            <em className="ti ti-settings" />
                            {translate('Menu-AccessRights')}
                            <div className="TopMenuIcon">{isLogExpand ? <em className="ti ti-angle-down" /> : <em className="ti ti-angle-right" />}</div>
                        </a>
                    </li>
                }
                {isAccessRightsExpand &&
                    <div className="SubMenu">
                        {(supervisorAccessRights[PAGEID.VfaspAccessRights] && supervisorAccessRights[PAGEID.VfaspAccessRights].ReadAccess === ACCESSRIGHTSTYPE.Yes) &&
                            <li>
                                <a href="/vfaspaccessrights">
                                    <em className="ti ti-settings" />
                                    {translate('Menu-CASPAccessRights')}
                                </a>
                            </li>
                        }
                        {(supervisorAccessRights[PAGEID.AdminAccessRights] && supervisorAccessRights[PAGEID.AdminAccessRights].ReadAccess === ACCESSRIGHTSTYPE.Yes) &&
                            <li>
                                <a href="/supervisoraccessrights">
                                    <em className="ti ti-angle-right" />
                                    <div className="SubMenuText">{translate('Menu-SupervisorAccessRights')}</div>
                                </a>
                            </li>
                        }
                        {(supervisorAccessRights[PAGEID.DefaultAdminAccessRights] && supervisorAccessRights[PAGEID.DefaultAdminAccessRights].ReadAccess === ACCESSRIGHTSTYPE.Yes) &&
                            <li>
                                <a href="/defaultaccessrights">
                                    <em className="ti ti-angle-right" />
                                    <div className="SubMenuText">{translate('Menu-DefaultAccessRights')}</div>
                                </a>
                            </li>
                        }
                    </div>
                }

            </ul>

            {/* .user-icon-nav */}
            <div className="user-sidebar-sap" />
            {/* .user-nav */}
            <div className="d-lg-none">
                <div className="user-sidebar-sap" />
                <div className="gaps-1x" />
                <ul className="topbar-action-list">
                    <li className="topbar-action-item topbar-action-link">
                        <a href="#">
                            <em className="ti ti-home" /> {translate('Home')}
                        </a>
                    </li>
                    {/* .topbar-action-item */}
                    <li className="dropup topbar-action-item topbar-action-language">
                        <a href="#" data-bs-toggle="dropdown" aria-haspopup="true">
                            {" "}
                            {props.locale === 'en-us' ? 'EN' : 'JP'} <em className="ti ti-angle-up" />{" "}
                        </a>
                        <ul className="dropdown-menu">
                            <li>
                                <a href="#" onClick={(e) => {
                                    e.preventDefault();
                                    props.actionChangeLanguage(LOCALES.JAPANESE);
                                }}>JP</a>
                            </li>
                            <li>
                                <a href="#" onClick={(e) => {
                                    e.preventDefault();
                                    props.actionChangeLanguage(LOCALES.ENGLISH);
                                }}>EN</a>
                            </li>
                        </ul>
                    </li>
                    {/* .topbar-action-item */}
                </ul>
                {/* .topbar-action-list */}
            </div>

            {/* Confirmaiton dialog */}
            <Dialog />
        </div>
    ) : "";
};

const mapStateToProps = state => {
    return {
        locale: state.siteLayout.locale,
        sideBarMobile: state.siteLayout.sideBarMobile,
        supervisor: state.remote.supervisor
    };
};

export default connect(mapStateToProps, {
    actionChangeLanguage
})(SidebarSupervisor);